import { Outlet } from "react-router-dom";
import { Navigation } from "../navigation/navigation";
import styled from 'styled-components';

const Container = styled.div`
    margin-left: 50px;
    margin-right: 50px;
    min-height: calc(100vh - 80px);


    @media (max-width: 1024px) {
        margin-left: 20px;
        margin-right: 20px;
    }

`;

export function RootLayout() {
    return (
        <>
            <Navigation />
            <Container>
                <Outlet />
            </Container>
        </>
    )
}